module.exports = __webpack_public_path__ + "img/mp4.92aa7687.svg";